
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import VisibleOptions from "@/components/widgets/VisibleOptions.vue";
import mixin from "./mixin";
import * as modals from "@/lib/modals";


@Component({
  name: 'UncompletedOrdersModal',
  
})
export default class UncompletedOrdersModal extends Mixins(mixin) {
  @Prop({ default: 0 })
  uncompletedOrdersCount: number;

  @Prop({ default: false })
  value: boolean;

  @Watch("value")
  valueChanged(val) {
    this.modalIsVisible = val;
  }

  async okClicked() {
    this.$emit('closeUOModal')
  }
}
